import { useEnterpriseConfig } from '@laigu/store';

const useHideLogo = () => {
  const { enterpriseConfig } = useEnterpriseConfig('', '', { refresh: false });
  const isHide = enterpriseConfig?.need_hide_logo;
  if (isHide !== undefined) localStorage.setItem('isHide', isHide);
  return { isHide };
};

export default useHideLogo;
